import { render, staticRenderFns } from "./VotersList.vue?vue&type=template&id=fce7101a"
import script from "./VotersList.vue?vue&type=script&lang=js"
export * from "./VotersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports